__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "opsyms";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/cdk/a11y", "15.2.9", () => (__webpack_require__.e(4218).then(() => (() => (__webpack_require__(4218))))));
			register("@angular/cdk/accordion", "15.2.9", () => (__webpack_require__.e(279).then(() => (() => (__webpack_require__(2088))))));
			register("@angular/cdk/bidi", "15.2.9", () => (__webpack_require__.e(2867).then(() => (() => (__webpack_require__(2867))))));
			register("@angular/cdk/clipboard", "15.2.9", () => (__webpack_require__.e(4632).then(() => (() => (__webpack_require__(6079))))));
			register("@angular/cdk/coercion", "15.2.9", () => (__webpack_require__.e(8971).then(() => (() => (__webpack_require__(8971))))));
			register("@angular/cdk/collections", "15.2.9", () => (__webpack_require__.e(1755).then(() => (() => (__webpack_require__(1755))))));
			register("@angular/cdk/dialog", "15.2.9", () => (__webpack_require__.e(245).then(() => (() => (__webpack_require__(2529))))));
			register("@angular/cdk/drag-drop", "15.2.9", () => (__webpack_require__.e(3273).then(() => (() => (__webpack_require__(8085))))));
			register("@angular/cdk/keycodes", "15.2.9", () => (__webpack_require__.e(8456).then(() => (() => (__webpack_require__(8456))))));
			register("@angular/cdk/layout", "15.2.9", () => (__webpack_require__.e(3278).then(() => (() => (__webpack_require__(3278))))));
			register("@angular/cdk/observers", "15.2.9", () => (__webpack_require__.e(3773).then(() => (() => (__webpack_require__(3773))))));
			register("@angular/cdk/overlay", "15.2.9", () => (__webpack_require__.e(5895).then(() => (() => (__webpack_require__(5895))))));
			register("@angular/cdk/platform", "15.2.9", () => (__webpack_require__.e(9107).then(() => (() => (__webpack_require__(9107))))));
			register("@angular/cdk/portal", "15.2.9", () => (__webpack_require__.e(7520).then(() => (() => (__webpack_require__(7520))))));
			register("@angular/cdk/scrolling", "15.2.9", () => (__webpack_require__.e(5430).then(() => (() => (__webpack_require__(5430))))));
			register("@angular/cdk/table", "15.2.9", () => (__webpack_require__.e(8747).then(() => (() => (__webpack_require__(9673))))));
			register("@angular/cdk/text-field", "15.2.9", () => (__webpack_require__.e(1375).then(() => (() => (__webpack_require__(5804))))));
			register("@angular/cdk", "15.2.9", () => (__webpack_require__.e(8684).then(() => (() => (__webpack_require__(6507))))));
			register("@angular/common/http", "15.2.10", () => (__webpack_require__.e(8798).then(() => (() => (__webpack_require__(8987))))));
			register("@angular/common", "15.2.10", () => (__webpack_require__.e(1129).then(() => (() => (__webpack_require__(4666))))));
			register("@angular/core", "15.2.10", () => (__webpack_require__.e(2560).then(() => (() => (__webpack_require__(2560))))));
			register("@angular/router", "15.2.10", () => (__webpack_require__.e(5636).then(() => (() => (__webpack_require__(9706))))));
			register("@xpo-ltl/config-manager", "15.1.3", () => (__webpack_require__.e(5896).then(() => (() => (__webpack_require__(9162))))));
			register("@xpo-ltl/ngx-ops-state", "15.0.7", () => (__webpack_require__.e(612).then(() => (() => (__webpack_require__(6746))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};